import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { DeviceSettingsProvider } from './context/DeviceSettingsContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';


ReactDOM.render(
  <React.StrictMode>
    <DeviceSettingsProvider>
      <App />
    </DeviceSettingsProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorkerRegistration.unregister();
reportWebVitals();
